/* ===========================================================
   CUSTOM HEADER FUNCTIONALITY
   =========================================================== */
(function() {
  'use strict';

  // Store interval ID for cleanup
  let announcementInterval = null;

  // Initialize all functionality
  function init() {
    initAnnouncementSlider();
    initSearchModal();
    initMobileMenu();
    initShopifyFeatures();
  }

  // === Announcement Slider ===
  function initAnnouncementSlider() {
    const announcements = document.querySelectorAll('.announcement');
    if (announcements.length === 0) return;

    let current = 0;

    function showAnnouncement(index) {
      announcements.forEach(a => a.classList.remove('active'));
      if (announcements[index]) {
        announcements[index].classList.add('active');
      }
    }

    const prevBtn = document.querySelector('.announcement-prev');
    const nextBtn = document.querySelector('.announcement-next');
    
    if (prevBtn && announcements.length > 1) {
      prevBtn.addEventListener('click', () => {
        current = (current - 1 + announcements.length) % announcements.length;
        showAnnouncement(current);
        // Reset auto-advance timer
        resetAnnouncementInterval();
      });
    }
    
    if (nextBtn && announcements.length > 1) {
      nextBtn.addEventListener('click', () => {
        current = (current + 1) % announcements.length;
        showAnnouncement(current);
        // Reset auto-advance timer
        resetAnnouncementInterval();
      });
    }

    function resetAnnouncementInterval() {
      if (announcementInterval) {
        clearInterval(announcementInterval);
      }
      if (announcements.length > 1) {
        announcementInterval = setInterval(() => {
          current = (current + 1) % announcements.length;
          showAnnouncement(current);
        }, 5000);
      }
    }

    if (announcements.length > 1) {
      showAnnouncement(current);
      resetAnnouncementInterval();
    }
  }

  // === Search Modal Functionality ===
  function initSearchModal() {
    const modal = document.getElementById('search-modal');
    if (!modal) return;

    const openSearchModal = (e) => {
      e?.stopPropagation();
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';

        const searchInput = modal.querySelector('#Search-In-Modal');
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 100);
        }
      }
    };

    const closeSearchModal = (e) => {
      e?.stopPropagation();
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';

        const searchInput = modal.querySelector('#Search-In-Modal');
        if (searchInput) searchInput.value = '';

        const resetButton = modal.querySelector('.reset__button');
        if (resetButton) resetButton.classList.add('hidden');

        // Reset predictive search if using native Shopify component
        const predictiveSearch = modal.querySelector('[data-predictive-search]');
        if (predictiveSearch && !predictiveSearch.querySelector('predictive-search')) {
          predictiveSearch.innerHTML = `
            <div class="predictive-search__loading-state">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>`;
        }
      }
    };

    const searchInput = modal.querySelector('#Search-In-Modal');
    const resetButton = modal.querySelector('.reset__button');

    if (searchInput && resetButton) {
      searchInput.addEventListener('input', function() {
        resetButton.classList.toggle('hidden', !this.value.trim());
      });

      resetButton.addEventListener('click', () => {
        searchInput.value = '';
        resetButton.classList.add('hidden');
        searchInput.focus();

        const predictiveSearch = modal.querySelector('[data-predictive-search]');
        if (predictiveSearch && !predictiveSearch.querySelector('predictive-search')) {
          predictiveSearch.innerHTML = `
            <div class="predictive-search__loading-state">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>`;
        }
      });
    }

    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeSearchModal(e);
    });

    document.querySelectorAll('.search-toggle').forEach(btn => {
      btn.addEventListener('click', openSearchModal);
    });

    const closeBtn = document.getElementById('search-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeSearchModal);
    }

    // Escape key handler
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (modal && modal.classList.contains('active')) {
          closeSearchModal(e);
        }
        const nav = document.querySelector('.main-nav');
        if (nav && nav.classList.contains('active')) {
          if (window.closeMobileMenu) {
            window.closeMobileMenu();
          }
        }
      }
    });
  }

  // === Mobile Menu Toggle ===
  function initMobileMenu() {
    const mobileBtn = document.querySelector('.mobile-menu-btn');
    const nav = document.querySelector('.main-nav');
    const overlay = document.getElementById('mobile-drawer-overlay');
    const closeBtn = document.querySelector('.mobile-drawer-close');
    
    if (!mobileBtn) {
      console.error('Mobile menu button not found!');
      return;
    }
    
    if (!nav) {
      console.error('Main navigation not found!');
      return;
    }
    
    // Ensure button is visible and clickable
    mobileBtn.style.display = 'flex';
    mobileBtn.style.pointerEvents = 'auto';
    mobileBtn.style.zIndex = '10001';
    mobileBtn.style.position = 'relative';
    
    // Mobile menu initialized successfully
    console.log('Mobile menu initialized - button found:', mobileBtn);

    let scrollPosition = 0;
    let focusableElements = [];
    let firstFocusableElement = null;
    let lastFocusableElement = null;

    function trapFocus(container) {
      focusableElements = container.querySelectorAll(
        'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      firstFocusableElement = focusableElements[0];
      lastFocusableElement = focusableElements[focusableElements.length - 1];
      
      container.addEventListener('keydown', handleFocusTrap);
    }

    function releaseFocus() {
      if (focusableElements.length > 0) {
        nav.removeEventListener('keydown', handleFocusTrap);
      }
      focusableElements = [];
      firstFocusableElement = null;
      lastFocusableElement = null;
    }

    function handleFocusTrap(e) {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement?.focus();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement?.focus();
        }
      }
    }

    function closeMobileMenu() {
      nav.classList.remove('active');
      mobileBtn.classList.remove('active');
      mobileBtn.setAttribute('aria-expanded', 'false');
      mobileBtn.innerHTML = '<i class="fas fa-bars"></i>';
      
      if (overlay) {
        overlay.classList.remove('active');
        overlay.setAttribute('aria-hidden', 'true');
      }
      
      // Restore scroll position
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (scrollPosition) {
        window.scrollTo(0, scrollPosition);
      }

      // Close all dropdowns
      document.querySelectorAll('.nav-item.has-dropdown.active').forEach(item => {
        item.classList.remove('active');
      });

      // Release focus trap
      releaseFocus();
      
      // Return focus to menu button
      mobileBtn.focus();
    }
    
    function openMobileMenu() {
      // Save scroll position
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      console.log('Opening mobile menu...');
      console.log('Nav element:', nav);
      console.log('Overlay element:', overlay);
      
      // Add active class to nav first
      nav.classList.add('active');
      console.log('Nav active class added, has active:', nav.classList.contains('active'));
      
      // Add active class to button
      mobileBtn.classList.add('active');
      mobileBtn.setAttribute('aria-expanded', 'true');
      mobileBtn.innerHTML = '<i class="fas fa-times"></i>';
      
      // Show overlay
      if (overlay) {
        overlay.classList.add('active');
        overlay.setAttribute('aria-hidden', 'false');
        console.log('Overlay activated');
      } else {
        console.error('Overlay not found!');
      }
      
      // Prevent body scroll
      if (window.innerWidth <= 768) {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.width = '100%';
      }

      // Trap focus in drawer
      trapFocus(nav);
      
      // Focus first focusable element (close button)
      setTimeout(() => {
        const firstElement = nav.querySelector('button, a, select');
        if (firstElement) firstElement.focus();
      }, 100);
      
      console.log('Mobile menu should now be open');
    }

    // Attach click handler with proper event handling
    function handleMobileMenuClick(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      console.log('Mobile menu clicked, current state:', nav.classList.contains('active'));
      if (nav.classList.contains('active')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    }
    
    // Expose to global scope for inline onclick fallback
    window.toggleMobileMenu = handleMobileMenuClick;
    window.closeMobileMenu = closeMobileMenu;
    
    // Attach event listeners directly (don't clone to preserve inline onclick)
    mobileBtn.addEventListener('click', handleMobileMenuClick, { passive: false, capture: true });
    mobileBtn.addEventListener('touchend', function(e) {
      e.preventDefault();
      e.stopPropagation();
      handleMobileMenuClick(e);
    }, { passive: false, capture: true });
    
    // Touch start for better mobile support
    mobileBtn.addEventListener('touchstart', function(e) {
      // Mark that touch started
      mobileBtn.setAttribute('data-touch', 'true');
    }, { passive: true });
    
    // Also handle click events
    mobileBtn.addEventListener('mousedown', function(e) {
      mobileBtn.setAttribute('data-touch', 'false');
    });
    
    // Ensure inline onclick also works
    if (mobileBtn.onclick === null || !mobileBtn.getAttribute('onclick')) {
      mobileBtn.setAttribute('onclick', 'if(window.toggleMobileMenu) window.toggleMobileMenu(event); return false;');
    }

    // Close button handler
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        closeMobileMenu();
      });
    }

    // Overlay click handler
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        e.stopPropagation();
        closeMobileMenu();
      });
    }

    // === Mobile Dropdown Handling ===
    function initializeMobileDropdowns() {
      const dropdownItems = document.querySelectorAll('.nav-item.has-dropdown');
      
      dropdownItems.forEach(item => {
        const link = item.querySelector('.nav-link');
        if (!link) return;

        // Remove existing listeners by cloning (cleaner approach)
        const newLink = link.cloneNode(true);
        link.parentNode.replaceChild(newLink, link);

        if (window.innerWidth <= 768) {
          item.classList.remove('active');
          newLink.addEventListener('click', function (e) {
            if (item.classList.contains('has-dropdown')) {
              e.preventDefault();
              e.stopPropagation();
              dropdownItems.forEach(otherItem => {
                if (otherItem !== item && otherItem.classList.contains('active')) {
                  otherItem.classList.remove('active');
                }
              });
              const wasActive = item.classList.contains('active');
              item.classList.toggle('active');
              if (wasActive) {
                const href = this.getAttribute('href');
                if (href && href !== '#') {
                  window.location.href = href;
                }
              }
            }
          });
        }
      });

      // Close dropdowns when clicking outside
      const clickOutsideHandler = function(e) {
        if (window.innerWidth <= 768) {
          const dropdowns = document.querySelectorAll('.nav-item.has-dropdown.active');
          const clickedInside = e.target.closest('.nav-item.has-dropdown');
          const clickedBtn = e.target.closest('.mobile-menu-btn');
          if (!clickedInside && !clickedBtn) {
            dropdowns.forEach(dropdown => dropdown.classList.remove('active'));
          }
        }
      };

      // Remove old listener if exists, then add new one
      document.removeEventListener('click', clickOutsideHandler);
      document.addEventListener('click', clickOutsideHandler);

      // Close menu after dropdown link click
      document.querySelectorAll('.dropdown a').forEach(dropdownLink => {
        dropdownLink.addEventListener('click', function() {
          if (window.innerWidth <= 768) {
            const parentDropdown = this.closest('.nav-item.has-dropdown');
            if (parentDropdown) {
              parentDropdown.classList.remove('active');
              setTimeout(() => closeMobileMenu(), 300);
            }
          }
        });
      });
    }

    initializeMobileDropdowns();

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth > 768) {
          closeMobileMenu();
          document.querySelectorAll('.nav-item.has-dropdown.active').forEach(item => {
            item.classList.remove('active');
          });
        } else {
          initializeMobileDropdowns();
        }
      }, 250);
    });

    // Expose closeMobileMenu for escape key handler
    window.closeMobileMenu = closeMobileMenu;
  }

  // === Shopify Core Functionality ===
  function initShopifyFeatures() {
    // 1. AJAX Add-to-Cart
    document.body.addEventListener("submit", async (e) => {
  const form = e.target.closest('form[action="/cart/add"]');
  if (!form) return;

  // 🚫 Skip AJAX handler for PreProduct buttons
  if (form.querySelector("[data-native-pre-order-btn]")) {
    console.log("⚠ Skipping AJAX add-to-cart for PreProduct");
    return; // Allow PreProduct to handle the submission
  }


      e.preventDefault();
      const formData = new FormData(form);

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { "Accept": "application/json" },
        });

        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.description || "Could not add item to cart.");
        }

        const data = await response.json();
        console.log("✅ Product added to cart:", data);
        
        await updateCartIconBubble();
        openCartDrawer();
      } catch (error) {
        console.error("Error adding to cart:", error);
        // Show user-friendly error message
        if (error.message) {
          alert(error.message);
        } else {
          alert("Could not add item to cart. Please try again.");
        }
      }
    });

    // === 2. Currency Selector (Refresh Same Page, No Redirect) ===
    // Handle both announcement bar and mobile drawer currency selectors
    document.querySelectorAll('.currency-selector').forEach(select => {
      select.addEventListener('change', function() {
        const selectedCurrency = this.value;
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('currency', selectedCurrency);

        if (window.Shopify && Shopify.designMode) {
          window.location = currentUrl.toString();
        } else {
          window.location.assign(currentUrl.toString());
        }
      });
    });

    // 3. Cart Bubble Sync
    async function updateCartIconBubble() {
      try {
        const res = await fetch("/cart.js");
        if (!res.ok) {
          throw new Error("Failed to fetch cart data");
        }

        const cart = await res.json();
        const bubble = document.querySelector("#cart-icon-bubble .cart-count-bubble");

        if (bubble) {
          if (cart.item_count > 0) {
            bubble.innerHTML = `
              <span aria-hidden="true">${cart.item_count}</span>
              <span class="visually-hidden">Items in cart: ${cart.item_count}</span>
            `;
            bubble.style.display = "flex";
          } else {
            bubble.style.display = "none";
          }
        }
        
        // Ensure cart icon stays as basket-shopping
        lockCartIcon();
      } catch (error) {
        console.error("Cart bubble update failed:", error);
      }
    }
    
    // Lock cart icon to basket-shopping and prevent changes
    function lockCartIcon() {
      const cartIcon = document.querySelector("#cart-icon-bubble .svg-wrapper");
      if (cartIcon) {
        // Remove any SVG elements that might be injected
        const svgs = cartIcon.querySelectorAll("svg");
        svgs.forEach(svg => svg.remove());
        
        // Ensure FontAwesome icon is present
        const icon = cartIcon.querySelector("i.fa-basket-shopping");
        if (!icon) {
          // If icon is missing, add it back
          const existingIcon = cartIcon.querySelector("i");
          if (existingIcon && !existingIcon.classList.contains("fa-basket-shopping")) {
            existingIcon.className = "fas fa-basket-shopping";
          } else if (!existingIcon) {
            cartIcon.innerHTML = '<i class="fas fa-basket-shopping"></i>';
          }
        } else {
          // Ensure it has the correct classes
          icon.className = "fas fa-basket-shopping";
        }
      }
    }
    
    // Watch for changes to the cart icon and lock it
    function watchCartIcon() {
      const cartIconBubble = document.getElementById("cart-icon-bubble");
      if (!cartIconBubble) return;
      
      const observer = new MutationObserver((mutations) => {
        lockCartIcon();
      });
      
      observer.observe(cartIconBubble, {
        childList: true,
        subtree: true,
        attributes: false
      });
      
      // Also lock on cart updates
      document.addEventListener("cart:updated", lockCartIcon);
      document.addEventListener("cart:refresh", lockCartIcon);
    }

    // 4. Cart Drawer Refresh
    async function openCartDrawer() {
      // Check if cart drawer setting is enabled
      const drawer = document.querySelector("#shopify-section-cart-drawer");
      if (!drawer) {
        // If no drawer, just update the bubble and redirect to cart page
        console.log("Cart drawer not found, redirecting to cart page");
        return;
      }

      try {
        const res = await fetch("/?section_id=cart-drawer");
        if (!res.ok) {
          throw new Error("Failed to load cart drawer");
        }

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newDrawer = doc.querySelector("#shopify-section-cart-drawer");

        if (newDrawer) {
          drawer.innerHTML = newDrawer.innerHTML;
          drawer.classList.add("active");
        }
      } catch (err) {
        console.error("Cart drawer reload failed:", err);
      }
    }

    // Initial cart bubble update
    updateCartIconBubble();
    
    // Lock cart icon and watch for changes
    lockCartIcon();
    watchCartIcon();
    
    // Lock icon on page load and after any cart updates
    setTimeout(lockCartIcon, 100);
    setTimeout(lockCartIcon, 500);
    setTimeout(lockCartIcon, 1000);
  }

  // Cleanup on page unload
  window.addEventListener('beforeunload', function() {
    if (announcementInterval) {
      clearInterval(announcementInterval);
      announcementInterval = null;
    }
  });

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Use setTimeout to ensure DOM is fully ready
    setTimeout(init, 0);
  }
})();
